/**
 * Vue.js mixin for highlights table cells and rows
 */
export default {
    data() {
        return {
            selectedColumn: null,
            selectedRow: null,
            hoveredRow: null,
            hoveredColumn: null
        };
    },
    methods:{
        highlightColumn(row, column) {
            switch (true) {
            case this.selectedColumn == column && this.selectedRow == row:
                return 'both-selected';
                break;
            case this.selectedRow == row:
                return 'selected--row';
                break;
            case this.selectedColumn == column:
                return 'selected--column';
                break;
            }
        },
        lightHighlightColumn(row, column) {
            switch (true) {
            case this.hoveredColumn == column && this.hoveredRow == row:
                return 'both-hovered';
                break;
            case this.hoveredRow == row:
                return 'hovered--row';
                break;
            case this.hoveredColumn == column:
                return 'hovered--column';
                break;
            }
        },
        hoverColumn(column) {
            this.hoveredColumn = column - 1;
        },
        hoverRow(row) {
            this.hoveredRow = row;
        },
        selectColumn(column) {
            return this.selectedColumn == column - 1 ? this.selectedColumn = null : this.selectedColumn = column - 1;

        },
        selectRow(row) {
            return this.selectedRow == row ? this.selectedRow = null : this.selectedRow = row;
        },
    }
};



// WEBPACK FOOTER //
// ./src/pages/resources-and-tools/OgdenTables/mixins/Selector.js